import { ResourceProps } from "@refinedev/core";

export const resources: ResourceProps[] = [
  {
    name: "suppliers",
    list: "/suppliers",
    create: "/suppliers/create",
    edit: "/suppliers/edit/:id",
    show: "/suppliers/show/:id",
    meta: {
      canDelete: true,
      label: "Suppliers",
    },
  },
  {
    name: "customers",
    list: "/customers",
    create: "/customers/create",
    edit: "/customers/edit/:id",
    show: "/customers/show/:id",
    meta: {
      canDelete: true,
      label: "Customers",
    },
  },
  {
    name: "services",
    list: "/services",
    create: "/services/create",
    edit: "/services/edit/:id",
    show: "/services/show/:id",
    meta: {
      canDelete: true,
      label: "Services",
    },
  },
  {
    name: "sales-orders",
    list: "/sales/orders",
    create: "/sales/orders/create",
    edit: "/sales/orders/edit/:id",
    show: "/sales/orders/show/:id",
    meta: {
      canDelete: true,
      label: "Sales Orders",
    },
  },
  {
    name: "purchase-orders",
    list: "/purchase/orders",
    create: "/purchase/orders/create",
    edit: "/purchase/orders/edit/:id",
    show: "/purchase/orders/show/:id",
    meta: {
      canDelete: true,
      label: "Purchase Orders",
    },
  },
  {
    name: "inventory",
    list: "/inventory",
    meta: {
      label: "Inventory",
    },
  },
  {
    name: "categories",
    list: "/categories",
    create: "/categories/create",
    edit: "/categories/edit/:id",
    show: "/categories/show/:id",
    meta: {
      canDelete: true,
      label: "Categories",
    },
  },
  {
    name: "materials",
    list: "/materials",
    create: "/materials/create",
    edit: "/materials/edit/:id",
    show: "/materials/show/:id",
    meta: {
      canDelete: true,
      label: "Materials",
    },
  },
  {
    name: "cutting",
    list: "/cutting",
    create: "/cutting/create",
    edit: "/cutting/edit/:id",
    show: "/cutting/show/:id",
    meta: {
      canDelete: true,
      label: "Cutting Orders",
    },
  },
  {
    name: "pricing",
    list: "/pricing",
    create: "/pricing/create",
    edit: "/pricing/edit/:id",
    show: "/pricing/show/:id",
    meta: {
      canDelete: true,
      label: "Price Lists",
    },
  },
  {
    name: "warehouse-checks",
    list: "/warehouse-checks",
    create: "/warehouse-checks/create",
    edit: "/warehouse-checks/edit/:id",
    show: "/warehouse-checks/show/:id",
    meta: {
      canDelete: true,
      label: "Warehouse Checks",
    },
  },
];